import { useEffect, DragEventHandler, useState, useRef } from "react";
import { ChangeAlertCallbackType } from '../../../Root';
import { useAFBFunction } from '../../../customwidgets/afb-company-admin/hooks/useAFBFunction';
import { CommonService } from "../../../../services/CommonService";

export const useClabeCreate = (open: boolean, onClose: Function, changeAlert: ChangeAlertCallbackType) => {
    const { handleClabeCreate } = useAFBFunction(changeAlert);
    const commonService = useRef<CommonService>();

    const [zPos, setZPos] = useState(45);
    const [data, setData] = useState([]);
    const [form, setForm] = useState(null);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [disabled, setDisabled] = useState<boolean>(true);
    const dropZoneRef = useRef<null | HTMLDivElement>(null);

    const parseJson = (csv) => {
        setLoading(true);
        setZPos(-1);
        setDisabled(true);
        setError(null);

        let f = form || {};
        let agent = localStorage.session ? JSON.parse(localStorage.session) : {};

        const reader = new FileReader();
        reader.onload = (e: any) => {
            const result = new Uint8Array(e.target.result);
            const workbook = window["XLSX"].read(result, { type: "array" });

            const firstSheetName = workbook.SheetNames[0];
            const worksheet = window["XLSX"].utils.sheet_to_json(
                workbook.Sheets[firstSheetName],
                { header: 1 }
            );

            const count = worksheet.filter((row) => row.length > 0).length;
            if (count > 1) {
                f["total_count"] = count - 1;
                f["file_name"] = csv.name;
                f["uuid_customer"] = data["uuid"];
                f["uuid_admin"] = agent["uuid"];

                const readerUrl = new FileReader();
                readerUrl.readAsDataURL(csv);
                readerUrl.onload = () => {
                    f["file_base_64"] = readerUrl.result;
                    setForm(JSON.parse(JSON.stringify(f)));
                };

                setForm(JSON.parse(JSON.stringify(f)));
                setDisabled(false);
            } else {
                setError("El archivo seleccionado está vacío");
                return;
            }
        };

        reader.readAsArrayBuffer(csv);
        setLoading(false);
        setZPos(45);
    };

    const onSelectFile = (e) => {
        let csv = e.target.files[0];
        let extension = (name) => {
            return ["csv", "xls", "xlsx"].indexOf(name.split('.').pop()) === -1 ? true : false
        }

        if (!csv) {
            changeAlert(true, "error", "Error en selección de archivo");
        } else if (extension(csv.name)) {
            changeAlert(true, "error", "Error: El tipo de archivo no es permitido.");
        } else {
            parseJson(csv);
        }
    };

    const onDownloadFile = async () => {
        setLoading(false);
        let path = "formats/workers.xlsx";

        if (path) {
            const request = await commonService.current.downloadFile(path);
            if (request.data.response === "OK") {
                window.open(request.data.content, "_blank");
            }
        }

        setLoading(false);
    };

    const handleOver: DragEventHandler<HTMLDivElement> = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (dropZoneRef.current) {
            dropZoneRef.current.style.borderColor = "#1890ff";
            dropZoneRef.current.style.borderWidth = "2px";
            dropZoneRef.current.style.backgroundColor = "rgba(119, 119, 255,0.1)";
        }
    };

    const handleLeave: DragEventHandler<HTMLDivElement> = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (dropZoneRef.current) {
            dropZoneRef.current.style.borderColor = "lightgray";
            dropZoneRef.current.style.borderWidth = "1px";
            dropZoneRef.current.style.backgroundColor = "transparent";
        }
    };

    const handleDrop: DragEventHandler<HTMLDivElement> = (event) => {
        event.preventDefault();
        event.stopPropagation();

        if (event.dataTransfer.files && event.dataTransfer.files.length > 0) {
            const filesToUpload = [];
            for (let i = 0; i < event.dataTransfer.files.length; i++) {
                filesToUpload.push(event.dataTransfer.files.item(i));
            }

            if (filesToUpload.length > 0) {
                parseJson(filesToUpload[0]);
                handleLeave(event);
            }
            event.dataTransfer.clearData();
        }
    };

    const onConfirm = async () => {
        setLoading(true);
        setZPos(-1);

        let payload = {
            info: form,
        };

        let resp = await handleClabeCreate(payload);
        if (resp) {
            changeAlert(true, "success", "La operación fue realizada con éxito");
            onClose("clabe");
        } else {
            setForm([]);
        }

        setZPos(45);
        setLoading(true);
    };

    const onFormReset = () => {
        setForm(null);
        setError(null);
        setDisabled(true);
    };

    useEffect(() => {
        commonService.current = new CommonService(changeAlert);
        
        if (!open) {
            setData([]);
            setForm(null);
            setError(null);
            setDisabled(true);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);

    return {
        zPos,
        form,
        error,
        loading,
        disabled,
        dropZoneRef,
        onConfirm,
        onSelectFile,
        handleOver,
        handleLeave,
        handleDrop,
        onDownloadFile,
        onFormReset
    };
};
